import React, { useState } from "react";
import cx from "classnames";
import { useStaticQuery, graphql } from "gatsby";
import ArticleDifficultyLevelSelector from "../../ArticleDifficultyLevelSelector";

import { convertSnakeToTitleCase } from "../../../utils";
import { defaultSelectedLevel } from "../LearnOurArticles";
import CloseIcon from "../../../assets/svgs/menu-close-icon.svg";

const DropDownFilter = ({
  selectedLevel,
  setSelectedLevel,
  categories,
  setSelectedCategories,
  resetCategories,
}) => {
  const data = useStaticQuery(graphql`
    query {
      filterIcon: file(relativePath: { eq: "images/icons/filter.svg" }) {
        publicURL
      }
    }
  `);

  const [_isDropdownOpen, _setIsDropdownOpen] = useState(false);
  const [_categories, _setCategories] = useState(categories);
  const [_level, _setLevel] = useState(selectedLevel);

  const _onToggleDropdown = () => {
    _setIsDropdownOpen(!_isDropdownOpen);

    if (!_isDropdownOpen) {
      _setCategories(categories);
      _setLevel(selectedLevel);
    }
  };

  const _onCategorySelect = ([cat, { isActive, isMain }]) => {
    _setCategories({
      ..._categories,
      [cat]: {
        isActive: !isActive,
        isMain,
      },
    });
  };

  const _onReset = () => {
    const activeAllCategories = resetCategories(categories, true);
    setSelectedCategories({ ...activeAllCategories });
    setSelectedLevel(defaultSelectedLevel);

    _setCategories({ ...activeAllCategories });
    _setLevel(defaultSelectedLevel);
  };

  const _onApplyFilters = () => {
    setSelectedCategories(_categories);
    setSelectedLevel(_level);
    _setIsDropdownOpen(false);
  };

  const CategorySummary = () => {
    const summary = Object.entries(_categories).filter(
      ([_, { isActive }]) => isActive
    );

    return (
      <div className="d-inline-block summary">
        {summary.slice(0, 2).map((entry, i) => (
          <button
            key={`dropdown-filtration-category-${i}`}
            className="button py-2 px-2 px-md-3 mr-1"
            onClick={() => _onCategorySelect(entry)}
          >
            {convertSnakeToTitleCase(entry[0])} &#215;
          </button>
        ))}
        {summary.length > 2 && (
          <>
            <span className="more mx-1 mx-md-2">...</span>
            <button className="button count py-2 px-3 ml-1">
              {summary.length - 2}
            </button>
          </>
        )}
      </div>
    );
  };

  return (
    <>
      <div id="learn-article-filtration__dropdown" className="dropdown">
        <button
          className="button category mb-0"
          type="button"
          id="dropdown-filter"
          data-bs-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          onClick={_onToggleDropdown}
        >
          <img
            src={data.filterIcon.publicURL}
            alt="filter"
            width={16}
            height={16}
          />
        </button>

        <div
          className={cx("dropdown-menu dropdown-menu-right", {
            show: _isDropdownOpen,
          })}
          aria-labelledby="dropdown-filter"
        >
          <div className="dropdown-item d-flex justify-content-between">
            <CategorySummary />
            <button
              className="button btn-close-menu ml-3 p-0"
              onClick={() => _setIsDropdownOpen(false)}
            >
              <CloseIcon />
            </button>
          </div>
          <div className="dropdown-divider" />
          <div className="dropdown-item d-flex flex-column">
            <span className="my-2">Difficulty</span>
            <ArticleDifficultyLevelSelector
              selectedLevel={_level}
              setSelectedLevel={_setLevel}
            />
          </div>
          <div className="dropdown-divider" />
          <div className="dropdown-item d-flex flex-column p-0">
            {Object.entries(_categories).map((entry, i) => (
              <div className="form-check" key={`dropdown-item-${i}`}>
                <label
                  className="w-100 mb-0 py-2 pr-3"
                  htmlFor={`checkbox-${entry[0]}`}
                >
                  <input
                    type="checkbox"
                    className="form-check-input ml-2"
                    id={`checkbox-${entry[0]}`}
                    checked={_categories[entry[0]].isActive}
                    onChange={(e) => {
                      _onCategorySelect(entry);

                      return e.checked;
                    }}
                  />
                  <span className="ml-4 pl-2">
                    {convertSnakeToTitleCase(entry[0])}
                  </span>
                </label>
              </div>
            ))}
          </div>

          <div className="my-2 my-md-3 ml-4">
            <button
              className="button button-secondary button-rounded px-4 py-1"
              onClick={_onReset}
            >
              Reset
            </button>
            <button
              className="button button-primary button-rounded ml-2 px-3 py-1"
              onClick={_onApplyFilters}
            >
              Apply Filters
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default DropDownFilter;
